import { IconButton, Tooltip } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

interface Props {
  dump: string;
  tooltip: string;
}

const CopyButton = ({ dump, tooltip }: Props) => {
  return (
    <CopyToClipboard text={dump}>
      <Tooltip arrow title={tooltip}>
        <IconButton>
          <FileCopyIcon />
        </IconButton>
      </Tooltip>
    </CopyToClipboard>
  );
};

export default CopyButton;
